import { FC, useMemo, useState } from 'react';
import {
  Heading,
  Button,
  Box,
  Flex,
  Spacer,
  HStack,
  Text,
  Menu,
  MenuButton,
  MenuList,
  IconButton,
  MenuItemOption,
  MenuOptionGroup
} from '@chakra-ui/react';
import RewardProgramsList from 'components/rewardPrograms/RewardProgramsList';
import { usePrograms } from 'hooks/query/usePrograms';
import { useWeb3React } from 'hooks/web3';
import { FaCog, FaFilter, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const RewardProgramsPage: FC = () => {
  const [showExpiredPrograms, setShowExpiredPrograms] = useState(false);
  const [showUnverified, setShowUnverified] = useState(true);
  const { data: programs } = usePrograms();
  const { account } = useWeb3React();

  const filteredPrograms = useMemo(() => {
    if (programs && account) {
      return programs.filter(
        (d) =>
          d.rewardProgram.owner === account.toLowerCase() ||
          d.rewardProgram.powerSwitchController === account.toLowerCase()
      );
    }
  }, [programs, account]);

  return (
    <>
      <Heading size='xl' textAlign='center' py={8}>
        Reward Programs
      </Heading>
      <Flex alignItems={['end', 'normal']}>
        <Spacer />
        <Box mb={3}>
          <HStack>
            <Menu closeOnSelect={false}>
              <MenuButton
                as={IconButton}
                aria-label='Filter'
                icon={<FaFilter />}
                variant='outline'
              />
              <MenuList>
                <MenuOptionGroup
                  title='List Options'
                  type='checkbox'
                  defaultValue={['showUnverified']}
                >
                  <MenuItemOption
                    value='showEnded'
                    onClick={() => setShowExpiredPrograms(!showExpiredPrograms)}
                  >
                    Show Ended
                  </MenuItemOption>
                  <MenuItemOption
                    value='showUnverified'
                    onClick={() => setShowUnverified(!showUnverified)}
                  >
                    Show Unverified
                  </MenuItemOption>
                </MenuOptionGroup>
              </MenuList>
            </Menu>
            {filteredPrograms && filteredPrograms.length > 0 && (
              <Button
                width='fit-content'
                variant='ghost'
                colorScheme='cyan'
                backgroundColor='gray.800'
                as={Link}
                to={'/manage'}
                leftIcon={<FaCog />}
                mr={2}
              >
                <Text display={['none', null, 'initial']}>
                  Manage your Programs
                </Text>
                <Text display={['initial', null, 'none']}>Manage</Text>
              </Button>
            )}
            <Button
              width='fit-content'
              variant='ghost'
              colorScheme='green'
              backgroundColor='gray.800'
              as={Link}
              to={'/onboarding'}
              leftIcon={<FaPlus />}
            >
              <Text display={['none', null, 'initial']}>Create Program</Text>
              <Text display={['initial', null, 'none']}>Create</Text>
            </Button>
          </HStack>
        </Box>
      </Flex>
      <RewardProgramsList
        programs={programs}
        showExpiredPrograms={showExpiredPrograms}
        showUnverified={showUnverified}
      />
    </>
  );
};

export default RewardProgramsPage;
